module.exports = __webpack_public_path__ + "img/ko_get.8be7307.png";